// extracted by mini-css-extract-plugin
module.exports = {"countdown":"qi","srOnly":"ri"};